import isEmpty from 'lodash/isEmpty';

import { setAccountExistent } from './auth';
import { socialLogInUser } from './social';

/**
 * Function to trick the app and make set it in the state after a call to an external provider
 * @param {string} url
 * @param {object: {authorization: {id_token, code}, isPrivateEmail, expirationTimestamp, email} } authenticationData
 */
export const onSkipSocialLinks = ({ socialProvider }) => (
    dispatch,
    getState,
) => {
    const { socialDataMock } = getState();
    const socialMock = socialDataMock[socialProvider];

    if (!isEmpty(socialMock)) {
        if (socialMock.email) {
            dispatch(setAccountExistent(socialMock.email));
        }

        if (socialProvider === 'apple' && AppleID) {
            // Prevents the AppleID library to launch javascript its default action
            AppleID.auth.signIn = () => {
                const appleConfirmation = confirm('Continue with apple?');

                if (appleConfirmation) {
                    return Promise.resolve(socialMock);
                } else {
                    return Promise.reject({ status: 'popup_closed_by_user' });
                }
            };
        }

        if (socialProvider === 'facebook' && window.FB) {
            window.FB = {};
            window.FB.login = () => {
                dispatch(socialLogInUser('facebook', socialMock));
            };
            window.FB.getLoginStatus = () => {};
        }
    }
};

export const onSkipEmailDelivery = ({ callback }) => {
    setTimeout(callback?.(), 5000);
};
